export const AffiliateIcon = () => {
  return (
    <svg fill='none' height='16' viewBox='0 0 16 16' width='16' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11 14V12.5M12.5 11H14M4.28747 7.46975L3.2268 8.5304C2.05524 9.70198 2.056 11.6012 3.22756 12.7728C4.39914 13.9444 6.2981 13.9446 7.46968 12.7731L8.5307 11.7123M3.5 5H2M5 2V3.5M7.46975 4.28783L8.5304 3.22717C9.70198 2.0556 11.6012 2.05526 12.7728 3.22683C13.9444 4.3984 13.9441 6.2981 12.7725 7.46968L11.7119 8.53032'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
